import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { Backdrop, CircularProgress, Container } from '@material-ui/core';
import { ImageCropHeader } from './image-crop-header';
import { SaveImage } from './save-image';
import { ImageCropper } from './image-cropper';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '100%',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export const ImageCropDialog = ({ id, image, setImage, open, setOpen, profile }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [croppedImage, setCroppedImage] = useState();

  return (
    <div>
      {loading ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color='inherit' />
        </Backdrop>
      ) : (
        <Dialog
          fullScreen
          open={open}
          onClose={() => setOpen(false)}
          TransitionComponent={Transition}
        >
          <ImageCropHeader setOpen={setOpen} />

          <Container className={classes.container}>

            <ImageCropper profile={profile} image={image} setCroppedImage={setCroppedImage} />

            <SaveImage
              setOpen={setOpen}
              id={id}
              croppedImage={croppedImage}
              image={image}
              setImage={setImage}
              setLoading={setLoading}
            />
          </Container>
        </Dialog>
      )}
    </div>
  );
};
